import React, {Component, Fragment} from 'react';
// import '../../assets/scss/style.scss'
import api from '../../utils/api';
import '../../assets/css/chat.css'
import connect from "react-redux/es/connect/connect";
import $ from "jquery"
import image from "../../assets/img/nophoto.png"
import {getCurrentProfile, getChatList, setOnlineInRedux} from "../../actions/profile";
import {io} from "socket.io-client";
import SingleAgentList from "../profile/singleAgentList";
import {CHAT,HOME} from "../../actions/types";
import Navbar from "../common/navbar/Navbar";
import HeroSection from "../common/HerroSection/hero-section";

// import SearchIcon from '@material-ui/icons/Search';
const socket = io('https://primeprivatenetwork.com');

class Chat extends Component {
    constructor(props) {
        super(props);
        this.state = {
            Id: '',
            isOnline: false,
            isSingleChat:false,
            user_id:'',
        };


        socket.on("connect", () => {
            this.setState({
                isOnline: true,
                socketId: socket.id
            });
        });

        socket.on("disconnect", () => {
            console.log({socketDisconnectId: socket.id});
            this.setState({
                isOnline: false,
            });
        });

    }

    componentDidMount() {
        document.title = "Chat | Prime Private Network";
        if (this.props.user) {
            socket.emit('userConnect', {userId: this.props.user._id});
            console.log({userDAta:this.props.user});
            this.props.getChatList(this.props.user._id);
        }
        $('.friend-drawer--onhover').on('click', function () {

            $('.chat-bubble').hide('slow').show('slow');

        });

        if (this.props.match.params.id ) {
            this.setState({isSingleChat:true,user_id:this.props.match.params.id})

        }


        //Socket Receivers
        socket.on('userConnect', message => {
            console.log({message});
        });

    }

    componentDidUpdate(prevProps, nextState) {
        if (prevProps.user !== this.props.user && this.props.user) {
            console.log({userDAta: this.props.user});
            // Connecting Socket
            socket.emit('userConnect', {userId: this.props.user._id});
            this.props.getChatList(this.props.user._id);
        }
        if (prevProps.match.params.id !== this.props.match.params.id ) {
            console.log(this.props.match.params.id,"params Id");
            this.setState({isSingleChat:true,user_id:this.props.match.params.id})
            }
    }

    render() {
        return (
            <Fragment>
                <Navbar scenario={window.location.pathname === "/home" ? HOME: CHAT}/>
                <HeroSection title={'Private Chat'}/>
                <SingleAgentList
                    socket={socket}
                />
            </Fragment>
        );
    }
 }

const mapStateToProps = state => {
    return {
        user: state.auth.user,
        connection: state.profile.connection,
        connectionLoader: state.profile.connectionLoader,
        chatLists: state.profile.chatLists,
        chatListsLoader: state.profile.chatListsLoader
    }
};

export default connect(mapStateToProps, {getChatList,setOnlineInRedux, getCurrentProfile})(Chat);
